import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, mergeProps as _mergeProps, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
import { ref, computed } from "vue";
import { useStore } from "@/store";
export default /*@__PURE__*/ _defineComponent({
    __name: 'TextSearch',
    props: {
        mongoplugin: {}
    },
    emits: ["start-search"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const store = useStore();
        const textQuery = ref("");
        const isFocused = ref(false);
        const isJson = computed(() => {
            const trimmed = (textQuery.value ?? "").trim();
            if (!trimmed.startsWith("{")) {
                return false;
            }
            try {
                JSON.parse(trimmed);
                return true;
            }
            catch {
                return false;
            }
        });
        const isJsonEnabled = computed(() => props.mongoplugin !== "N/A");
        function startSearch() {
            if (textQuery.value === "") {
                store.updateFreeText(null);
                store.updateMongoText(null);
            }
            else if (isJsonEnabled.value && isJson.value) {
                store.updateMongoText(textQuery.value);
                store.updateFreeText(null);
            }
            else {
                store.updateFreeText(textQuery.value);
                store.updateMongoText(null);
            }
            emit("start-search");
        }
        function clearSearch() {
            textQuery.value = "";
            store.updateFreeText(null);
            store.updateMongoText(null);
            emit("start-search");
        }
        return (_ctx, _cache) => {
            const _component_v_tooltip = _resolveComponent("v-tooltip");
            const _component_v_text_field = _resolveComponent("v-text-field");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["search-container", { 'search-expanded': isFocused.value }])
            }, [
                (textQuery.value !== '')
                    ? (_openBlock(), _createBlock(_component_v_tooltip, {
                        key: 0,
                        location: "bottom"
                    }, {
                        activator: _withCtx(({ props }) => [
                            _createElementVNode("span", _mergeProps(props, {
                                class: "text-caption text-primary mr-2 search-label",
                                style: { "white-space": "nowrap" }
                            }), _toDisplayString(isJsonEnabled.value
                                ? isJson.value
                                    ? "MongoDB query (MQL):"
                                    : "free text search:"
                                : "free text search:"), 17)
                        ]),
                        default: _withCtx(() => [
                            _cache[3] || (_cache[3] = _createElementVNode("span", null, "Enclose a JSON query in braces {} to have it interpreted as a direct MongoDB query.", -1))
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true),
                _createVNode(_component_v_text_field, {
                    modelValue: textQuery.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((textQuery).value = $event)),
                    placeholder: "Search datasets...",
                    "prepend-inner-icon": "mdi-magnify",
                    density: "compact",
                    variant: "outlined",
                    "hide-details": "",
                    "single-line": "",
                    rounded: "",
                    clearable: "",
                    class: "search-field",
                    onKeyup: _withKeys(startSearch, ["enter"]),
                    "onClick:clear": clearSearch,
                    onFocus: _cache[1] || (_cache[1] = ($event) => (isFocused.value = true)),
                    onBlur: _cache[2] || (_cache[2] = ($event) => (isFocused.value = false))
                }, null, 8, ["modelValue"])
            ], 2));
        };
    }
});
